<template>
	<div
		class="button"
		@click="$emit('click', $event)"
		:class="[color, { visible, disabled, loading }]"
	>
		<slot v-if="!loading" />
		<uiLoader v-else />
	</div>
</template>

<script>
export default {
	name: 'uiButton',
	props: {
		disabled: {
			type: Boolean,
			default: false,
		},
		loading: {
			type: Boolean,
			default: false,
		},
		visible: {
			type: Boolean,
			default: true,
		},
		color: {
			type: String,
			default: 'black',
		},
	},
}
</script>

<style lang="less" scoped>
@import '../../assets/app.less';

.button {
	// width: 100%;
	flex-shrink: 0;
	height: 40px;
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: 14px;
	font-weight: 600;
	background: #000;
	color: #fff;
	border-radius: 20px;
	transition: opacity 250ms ease;
	cursor: pointer;
	opacity: 0;
	pointer-events: none;
	position: relative;

	&:active {
		transform: scale(0.98);
	}

	&.accent {
		background: @accent;
		color: #fff;
	}

	&.light {
		background: @light;
		color: #000;
	}

	&.grey {
		background: @grey;
		color: #000;
	}

	&.dark {
		background: #44455b;
		color: #fff;
	}

	&.white {
		background: #fff;
		color: #000;
	}

	&.red {
		background: @light;
		color: red;
	}

	&.visible {
		pointer-events: all;
		opacity: 1;
	}

	&.disabled {
		opacity: 0.3;
		pointer-events: none;
		cursor: default;
	}

	&.loading {
		pointer-events: none;
		cursor: none;
	}
}
</style>
